import React from 'react'
import TurnCup from '../TurnCup'
import { sheetAccent } from '../../sheetAccents'
import './MobileLeaderboard.css'

const MobileLeaderboard = ({ players, calculateTotal, onPlayerClick, tab, turn }) => {
  const rankOf = new Map(
    players
      .map((player, index) => ({ index, total: calculateTotal(player) }))
      .sort((a, b) => b.total - a.total || a.index - b.index)
      .map((item, position) => [item.index, position + 1])
  )

  return (
    <div className="mobile-leaderboard">
      {players.map((player, playerIndex) => {
        const isActive = playerIndex === tab
        const isTurn = playerIndex === turn
        const rank = rankOf.get(playerIndex)
        return (
          <button
            type="button"
            key={player.id || playerIndex}
            className={`mobile-leaderboard-player${isActive ? ' is-active' : ''}${isTurn ? ' is-turn' : ''}${rank === 1 ? ' is-first' : ''}`}
            style={{ '--player-accent': sheetAccent(playerIndex) }}
            aria-label={isTurn ? `${player.name}, har turen` : player.name}
            onClick={() => onPlayerClick && onPlayerClick(playerIndex)}
          >
            <span className="mobile-leaderboard-rank">{rank}</span>
            <span className="mobile-leaderboard-copy">
              <span className="mobile-leaderboard-name">
                <span>{player.name}</span>
                {isTurn ? <TurnCup /> : null}
              </span>
              <span className="mobile-leaderboard-score">{calculateTotal(player)}</span>
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default MobileLeaderboard
